import { NestedTreeControl } from '@angular/cdk/tree';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTreeModule, MatTreeNestedDataSource } from '@angular/material/tree';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-report-outline',
  imports: [ MatTreeModule,MatIconModule,CommonModule ],
  templateUrl: './report-outline.html',
  styleUrl: './report-outline.scss',
  standalone:true
})
export class ReportOutline  {
  @Input() dataSource!: MatTreeNestedDataSource<any>;
  @Input() treeControl!: NestedTreeControl<any>;
  @Input() hasChild!: (index: number, node: any) => boolean;
  @Input() isTreeCollapsed = false;
  @Input() isTocOverlay = false; 
  @Output() onClose = new EventEmitter<void>();
  IsOutlineClosed = false;

  

  @Input() scrollTo(sectionId: string) {
    const element = document.getElementById('sectionContainer-' + sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }

  onCloseClicked() {
    this.IsOutlineClosed = !this.IsOutlineClosed;
    if (this.isTocOverlay) {
      // Emit event to parent to close the overlay
      this.onClose.emit();
    } else {
      // Toggle collapsed state for sidebar mode
      this.isTreeCollapsed = !this.isTreeCollapsed;
    }
  }
}
